import styles from './index.module.css'
export const CSSLoading = () => {
  return (
    <div className={styles.loading}>
      <div></div>
      <div></div>
      <div></div>
    </div>
  )
}